import { colors as themeColors } from './theme';
import { spacing } from './units';

export const aiInsightsLayout = {
  emptyStateTitleMarginBottom: spacing.xsmall,
  borderRadius: '20px',
  smallBorderRadius: '4px',
  titleFontSize: '18px',
  sectionTitleFontSize: '19px',
  titleFontWeight: 600,
  pillFontSize: '13px',
  descriptionFontSize: '14px',
  toggleFontSize: '13px',
  toggleFontWeight: 500,
  headerPadding: '16px 20px',
  contentPadding: '24px',
  printHeaderBorderColor: themeColors.text?.primary ?? '#1e293b',
  pillGap: '6px',
  listMarginLeft: '24px',
};
